import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '../Icon/Icon';
import { KeyboardShortcutIndicator } from '../KeyboardShortcutIndicator/KeyboardShortcutIndicator';
import MenuItem from '../Menu/MenuItem';
import { iconClass } from './ClassNames';
import MenuSection from '../Menu/MenuSection';
import { SUPER_SHOW_MARKDOWN_PREVIEW, SUPER_TOGGLE_SEARCH } from '@standardnotes/ui-services';
import { useMemo, useCallback } from 'react';
import { useKeyboardService } from '../KeyboardServiceProvider';
import { c } from 'ttag';
const SuperNoteOptions = ({ closeMenu }) => {
    const keyboardService = useKeyboardService();
    const markdownShortcut = useMemo(() => keyboardService.keyboardShortcutForCommand(SUPER_SHOW_MARKDOWN_PREVIEW), [keyboardService]);
    const findShortcut = useMemo(() => keyboardService.keyboardShortcutForCommand(SUPER_TOGGLE_SEARCH), [keyboardService]);
    const enableSuperMarkdownPreview = useCallback(() => {
        keyboardService.triggerCommand(SUPER_SHOW_MARKDOWN_PREVIEW);
    }, [keyboardService]);
    const findInNote = useCallback(() => {
        keyboardService.triggerCommand(SUPER_TOGGLE_SEARCH);
        closeMenu();
    }, [closeMenu, keyboardService]);
    return (_jsxs(MenuSection, { children: [_jsxs(MenuItem, { onClick: findInNote, children: [_jsx(Icon, { type: "search", className: iconClass }), c('B4.Notes.EditorOptions.Action').t `Find in note`, findShortcut && _jsx(KeyboardShortcutIndicator, { className: "ml-auto", shortcut: findShortcut })] }), _jsxs(MenuItem, { onClick: enableSuperMarkdownPreview, children: [_jsx(Icon, { type: "markdown", className: iconClass }), c('B4.Notes.EditorOptions.Action').t `Show Markdown`, markdownShortcut && _jsx(KeyboardShortcutIndicator, { className: "ml-auto", shortcut: markdownShortcut })] })] }));
};
export default SuperNoteOptions;
